<template>
  <div class="card p-4">
    <div class="text-center process mx-auto">
      <img width="218" height="150" class="mb-4" alt="uploading" :src="uploadingImage" />
      <h5 class="mb-4">Sedang Mengunggah...</h5>
      <p class="my-3" v-if="false">{{ fileName }}</p>
      <div class="text-start">
        <McProgressBar height="8px" :value="percentage" />
        <div class="d-flex align-items-center justify-content-between mt-4">
          <span class="__totalCount">{{ fileUploadedSize }} / {{ totalCount }} data</span>
          <span class="__percentage">{{ percentage }}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uploadingImage from '@/assets/images/import-device/upload-in-progress.png'
import McProgressBar from '@/components/McProgressBar'

export default {
  components: {
    McProgressBar,
  },
  props: {
    base64: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      totalCount: 0,
      fileUploadedSize: 0,
      percentage: 0,
      timer: null,
      fileName: '',
    }
  },
  computed: {
    uploadingImage() {
      return uploadingImage
    },
  },
  mounted() {
    this.generatePercentage()
  },
  beforeDestroy() {
    // this.percentage = 0
  },
  methods: {
    async generatePercentage() {
      const isSuccess = !this.$route.params.file.data && this.$route.params.file.includes('Success')
      this.totalCount = isSuccess ? 1 : Object.keys(this.$route.params.file?.data)?.length
      const param = [10, 30, 50, 70, 90, 100]
      for (const element of param) {
        setTimeout(() => {
          this.percentage = element
          this.fileUploadedSize = (element / 100) * this.totalCount
          setTimeout(() => {
            if (element === 100) {
              this.$router.push({
                name: 'Device Import Result',
                params: { file: this.$route.params.file },
              })
            }
          }, 1000)
        }, 1000)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.process {
  max-width: 300px;
}

.__totalCount {
  color: $teal-300;
}

.__percentage {
  color: $blue;
  font-size: 16px;
  font-weight: 600;
}
</style>
